import { useCallback } from 'react'
import { IconButton, Stack, styled, Typography } from '@mui/material'
import { CustomAction } from '@weblite-wapps/protocol'
import {
  useWappBookmarkData,
  useWappCustomActions,
} from 'weblite-web-wapprunner'
import { CloseIcon, HorizontalMenuIcon } from '$common/icons'
import { getWappTheme } from '$common/wapp-bar-theme'
import { WappPanel } from '$logic/wapp-panels'
import { sendCustomActionToWapp } from '$logic/wapp-communication/helper/wapps.helper'
import { showWappBarMenu } from '$comp/modals/wapp-bar-menu'

const Root = styled(Stack)`
  width: 100%;
  height: 54px;
  padding: 0 15px 0 7px;
  background-color: white;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  border-bottom: 1px solid #e6e6e6;
`

interface TitleProps {
  hasMargin: boolean
}
const Title = styled(Typography, {
  shouldForwardProp: prop => prop !== 'hasMargin',
})<TitleProps>`
  margin-right: ${props => (props.hasMargin ? 8 : 0)}px;
`

export function WappPanelHeader({
  wappId,
  wappSessionId,
}: {
  wappId: string
  wappSessionId: string
}) {
  const theme = getWappTheme(wappId) // can fetch this from wapp manifest?
  const wappCustomActions = useWappCustomActions(wappSessionId)
  const bookmarkData = useWappBookmarkData(wappSessionId)

  const sendEditEvent = useCallback(() => {
    sendCustomActionToWapp(wappSessionId, CustomAction.EDIT)
  }, [wappSessionId])

  const sendShareEvent = useCallback(() => {
    sendCustomActionToWapp(wappSessionId, CustomAction.SHARE)
  }, [wappSessionId])

  const sendDeleteEvent = useCallback(() => {
    sendCustomActionToWapp(wappSessionId, CustomAction.DELETE)
  }, [wappSessionId])

  const hasEdit = wappCustomActions.includes(CustomAction.EDIT)
  const hasShare = wappCustomActions.includes(CustomAction.SHARE)
  const hasDelete = wappCustomActions.includes(CustomAction.DELETE)
  // TODO: should be handled in another way
  const isOwner = hasEdit || hasDelete
  const shouldShowMenu = hasEdit || hasShare || hasDelete || bookmarkData

  return (
    <Root direction="row">
      <Stack direction="row">
        {theme.icon}

        <Title
          variant="subtitle1"
          sx={{ lineHeight: '23px', color: theme.color }}
          hasMargin={!!theme.icon}
        >
          {theme.name}
        </Title>
      </Stack>

      <Stack direction="row" spacing="4px" sx={{ direction: 'ltr' }}>
        <IconButton onClick={() => WappPanel.closeTopWapp()}>
          <CloseIcon sx={{ color: 'gray' }} />
        </IconButton>

        {shouldShowMenu && (
          <IconButton
            onClick={() =>
              showWappBarMenu({
                isOwner,
                hasEdit,
                hasDelete,
                hasShare,
                sendEditEvent,
                sendShareEvent,
                bookmarkData,
                sendDeleteEvent,
              })
            }
          >
            <HorizontalMenuIcon sx={{ color: 'gray' }} />
          </IconButton>
        )}

        {/* {(hasEdit || true) && ( */}
        {/*  <IconButton onClick={sendEditEvent}> */}
        {/*    <EditOutlinedIcon sx={{ color: 'gray' }} /> */}
        {/*  </IconButton> */}
        {/* )} */}
      </Stack>
    </Root>
  )
}
